const NODE_ENV = process.env.NODE_ENV || 'development'

// process.env does not work for new variables, add new ones into build/webpack.config
const serverUrl = process.env.REACT_APP_API_URL || 'https://instapap.herokuapp.com'
const serverUrlDev = process.env.REACT_APP_API_URL_DEV || 'localhost:3000'
const apiUrl = process.env.REACT_APP_API_VER || '/api/v1'

// console.log('process.env: ', process.env)

const development = {
  serverUrl: serverUrlDev,
  apiUrl: apiUrl
}

const production = {
  serverUrl: serverUrl,
  apiUrl: apiUrl
}

const test = {
  serverUrl: '',
  apiUrl: ''
}

module.exports = {
  production,
  development,
  test
}[NODE_ENV]



// WEBPACK FOOTER //
// ./config/react.js